import { DropdownOption } from "ui/components/Dropdown/Dropdown/types";

/** Tipovi razloga odbijanja e-računa (čl. 52) — moraju odgovarati backendu (N/U/O). */
export const REJECTION_REASON_TYPE_OPTIONS: DropdownOption[] = [
  { value: "N", text: "Bez utjecaja na porez" },
  { value: "U", text: "Utječe na porez" },
  { value: "O", text: "Ostalo" },
];
